export default "__VITE_ASSET__DDk8PReZ__"